export class authData  {
    authenticated:boolean = false;
    user:string = null;
    groups:Array<string> = [];
    updatedTime:Date = new Date();
    email:string = null;
    firstName:string = null;
    lastName: string = null;
  }